import commonFunc from '@/common/commonFunction';

import { defaultTaxPaperState } from './module-taxpaper-state';

export default {
	resetState(state) {
		Object.assign(state, defaultTaxPaperState);
	},
	updateTaxPaperList(state, res) {
		state.TaxPaperList.removeAll();
		state.TaxPaperList.append(res.Data.Data);
		state.TotalTaxPaperList = res.Data.Total;
	},
	updatePayerBankList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.PayerBankList.removeAll();
		state.PayerBankList.append(res.Data);
	},
	deleteTaxPaperList(state, res) {
		state.TaxPaperList.remove(res);
	},
	updatePayTaxPaymentSubmission(state, res) {
		state.PayTaxPaymentSubmission = res.Data;
	},
	updatePayTaxPaymentSubmissionDefault(state, res) {
		state.PayTaxPaymentSubmissionDefault = res.Data;
	},
	updateFileData(state, res) {
		state.PayTaxPaymentSubmission = res.Data;
	},
	regisSuccess: function(state, res) {
		state.regisSuccess = res.Success;
	},
	updateGIPInfo(state, res) {
		state.GIPInfo = res.Data;
	},
	updatedTaxPaperLoaded(state, data) {
		state.taxPaperLoaded = data;
	},
	updateBankByTaxPaper(state, data) {
		state.bankByTaxPaper = data;
	},
	updateMustPayTaxAmountReportData(state, data) {
		state.MustPayTaxAmountReportData = data.Data;
		state.MustPayTaxAmountReportSummary = data.SummaryData;
	},

	updateMustPayTaxAmountReportDetailData(state, data) {
		if (data) {
			state.MustPayTaxAmountReportDetailData.removeAll();
			state.MustPayTaxAmountReportDetailData = data.Data;
			state.MustPayTaxAmountReportDetailTotal = data.Total;
		}
	}
};
